import Vue from 'vue'
import * as api from '../api/esignApi'

const state = Vue.observable({
  templates: [],
  defaultData: {},
  signatures: [],
  signers: [],
  currentTemplate: {},
  currentSignature: {},
  meta: {},
  loading: false,
})

export function useEsignStore() {
  return {
    // State (reactive)
    get templates() { return state.templates },
    get defaultData() { return state.defaultData },
    get signatures() { return state.signatures },
    get signers() { return state.signers },
    get currentTemplate() { return state.currentTemplate },
    get currentSignature() { return state.currentSignature },
    get meta() { return state.meta },
    get loading() { return state.loading },

    // Getters
    get dropdownTemplates() {
      return state.templates.map(function (t) {
        return {
          id: t.id || t.Id,
          name: t.name || t.Name,
        }
      })
    },

    get dropdownSignatures() {
      return state.signatures.map(function (s) {
        return {
          id: s.id,
          name: s.name || ('Signature #' + s.id),
        }
      })
    },

    // --- Templates ---

    async listTemplates(holderType, holderId, params) {
      if (params === undefined) params = {}
      state.loading = true
      try {
        var result = await api.listTemplates(holderType, holderId, params)
        if (Array.isArray(result)) {
          state.templates = result
        } else if (result && typeof result === 'object' && Array.isArray(result.data)) {
          state.templates = result.data
        } else if (result && typeof result === 'object' && result.id) {
          state.templates = [result]
        } else {
          state.templates = []
        }
        return result
      } finally {
        state.loading = false
      }
    },

    async fetchDefaultData(params) {
      if (params === undefined) params = {}
      state.loading = true
      try {
        var result = await api.loadDefaultData(params)
        state.defaultData = result
        return result
      } finally {
        state.loading = false
      }
    },

    async createTemplate(holderType, holderId, data) {
      state.loading = true
      try {
        var result = await api.createTemplate(holderType, holderId, data)
        state.currentTemplate = result
        return result
      } finally {
        state.loading = false
      }
    },

    async updateTemplate(holderType, holderId, templateId, data) {
      state.loading = true
      try {
        var result = await api.updateTemplate(holderType, holderId, templateId, data)
        state.currentTemplate = result
        return result
      } finally {
        state.loading = false
      }
    },

    async deleteTemplate(holderType, holderId, templateId) {
      return api.deleteTemplate(holderType, holderId, templateId)
    },

    async openTemplateEditor(holderType, holderId, templateId) {
      return api.openTemplateEditor(holderType, holderId, templateId)
    },

    // --- Signatures ---

    async listSignatures(signableType, signableId, params) {
      if (params === undefined) params = {}
      state.loading = true
      try {
        var result = await api.listSignatures(signableType, signableId, params)
        state.signatures = result
        return result
      } finally {
        state.loading = false
      }
    },

    async getSignature(signableType, signableId, params) {
      if (params === undefined) params = {}
      var result = await api.listSignatures(signableType, signableId, params)
      return result
    },

    async fetchSigners(signableType, signableId, params) {
      if (params === undefined) params = {}
      state.loading = true
      try {
        var result = await api.getSigners(signableType, signableId, params)
        state.signers = result
        return result
      } finally {
        state.loading = false
      }
    },

    async createSignature(signableType, signableId, payload) {
      state.loading = true
      try {
        var result = await api.createSignature(signableType, signableId, payload)
        state.currentSignature = result
        return result
      } finally {
        state.loading = false
      }
    },

    async updateSignature(signableType, signableId, signatureId, data) {
      state.loading = true
      try {
        var result = await api.updateSignature(signableType, signableId, signatureId, data)
        state.currentSignature = result
        return result
      } finally {
        state.loading = false
      }
    },

    async sendSignature(signableType, signableId, signatureId) {
      state.loading = true
      try {
        return await api.sendSignature(signableType, signableId, signatureId)
      } finally {
        state.loading = false
      }
    },

    async downloadDocuments(signableType, signableId, signatureId) {
      return api.downloadDocuments(signableType, signableId, signatureId)
    },

    async refreshStatus(signableType, signableId, signatureId) {
      state.loading = true
      try {
        var result = await api.refreshStatus(signableType, signableId, signatureId)
        state.currentSignature = result
        return result
      } finally {
        state.loading = false
      }
    },

    async deleteSignature(signableType, signableId, signatureId) {
      return api.deleteSignature(signableType, signableId, signatureId)
    },

    resetCurrent() {
      state.currentSignature = {}
      state.currentTemplate = {}
    },
  }
}
